import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import LandingDemo from './pages/LandingDemo';
import AppShell from './AppShell';
import Registro from './pages/Registro';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingDemo />} />
      <Route path="/landing-v1" element={<Landing />} />
      <Route path="/registro" element={<Registro />} />
      <Route path="/app" element={<AppShell />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
